import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { amlButtonSx } from './amlScreeningStyles';
import AmlFlaggedProfileCard from './AmlFlaggedProfileCard';

export default function AmlScreeningApiResultsModal({ open, onClose, results = [], labels = {} }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>{labels.allResultsTitle ?? 'All screening matches'}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2.5}>
          {results.map((result, index) => (
            <AmlFlaggedProfileCard
              key={result.id ?? index}
              match={result}
              labels={labels}
              showType
              showMatchScore
              sx={{ mt: 0 }}
            />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1 }}>
        <Button variant="contained" onClick={onClose} sx={amlButtonSx}>
          {labels.close ?? 'Close'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
